import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import { ResponsiveBar, BarDatum } from '@nivo/bar';
import { OrdinalColorsInstruction } from '@nivo/colors';
import outerTheme from 'styles/themes/outer';
import { ReplacementLogByDate } from '../../models/device-management';
import { props as BarChartsOptions } from './ChartsOptions/BarChartsOptions';
import { formatAxisBottom } from './ChartsOptions/CommonOptions';

interface Props {
  data: ReplacementLogByDate[];
  chartData: Map<string, number | null>;
}

export const ReplacementsChart = (props: Props): JSX.Element => {
  const { chartData, data } = props;
  const colors: OrdinalColorsInstruction = outerTheme.palette.primary.main;

  for (const stat of data) {
    const day = moment(stat.date, 'YYYY-MM-D').format('YYYY-MM-DD');
    if (chartData.has(day)) {
      chartData.set(day, stat.count || 0);
    }
  }

  const barData: BarDatum[] = [];

  for (const [date, value] of chartData) {
    barData.push({ date, Replacements: value || 0 });
  }

  const maxValue = barData.some(e => e.Replacements > 10) ? 'auto' : 10;

  return (
    <Box
      data-filled={ barData.some(bar => bar.Replacements > 0) ? 'true' : 'false' }
      data-testid="chart"
      width="100%"
      height="100%"
    >
      <ResponsiveBar
        { ...BarChartsOptions }
        data={ barData }
        keys={ ['Replacements'] }
        colors={ colors }
        maxValue={ maxValue }
        defs={ [
          {
            id: 'lines',
            type: 'patternLines',
            background: 'inherit',
            color: outerTheme.palette.primary.light,
            rotation: 45,
            lineWidth: 6,
            spacing: 10
          },
        ] }
        fill={ [
          {
            match: {
              id: 'Replacements'
            },
            id: 'lines'
          }
        ] }
        axisTop={ {
          ...BarChartsOptions.axisTop,
          legend: 'Replacements',
        } }
        axisBottom={ {
          ...BarChartsOptions.axisBottom,
          format: formatAxisBottom(barData.length, 30)
        } }
      />
    </Box>
  );
};
